import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import boardExportService from './board-export.service';

export interface BoardExportState { }

const BoardExportStore: Module<BoardExportState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async get(
         context,
         {
            squad_ids,
            from,
            to,
            team_id,
            slot_state_keys,
         }: { squad_ids: number[]; from: string; to: string; team_id: number; slot_state_keys: string[] },
      ) {
         return await boardExportService.get({ squad_ids, from, to, team_id, slot_state_keys }).catch((error) => {
            if (!error.response.data?.errors || error.response.data?.errors.length == '0') return;

            for (const key in error.response.data.errors) {
               context.dispatch(
                  'addNotification',
                  {
                     notification: {
                        type: 'error',
                        message: error.response.data.errors[key][0],
                     },
                  },
                  { root: true },
               );
            }
         });
      },
      async post(
         context,
         {
            squad_ids,
            from,
            to,
            type,
            location_key,
            department_key,
         }: { squad_ids: number[]; from: string; to: string; type: string; location_key: string; department_key: string },
      ) {
         const BODY = { squad_ids, from, to, type, location_key, department_key };
         return await boardExportService.post(BODY);
      },
      async postNeeds(context, { squad_ids, from, to, board_id }: { squad_ids: number[]; from: string; to: string; board_id: number }) {
         const BODY = { squad_ids, from, to, board_id };
         return await boardExportService.postNeeds(BODY);
      },
      async postSlots(
         context,
         {
            squad_ids,
            from,
            to,
            board_id,
            slot_state_ids,
         }: { squad_ids: number[]; from: string; to: string; board_id: number; slot_state_ids: number[] },
      ) {
         const BODY = { squad_ids, from, to, board_id, slot_state_ids };
         return await boardExportService.postSlots(BODY);
      },
      async poolStructure(context, { pool_id }: { pool_id: number }) {
         const BODY = { pool_id };
         return await boardExportService.poolStructure(BODY);
      },
   },
};

export default BoardExportStore;
